export interface DspStreamData {
  date: string;
  spotify: number;
  youtube: number;
  appleMusic: number;
  amazon: number;
  other: number;
  [key: string]: string | number;
}

export interface DspTableRow {
  dsp: string;
  thisWeek: number;
  fytd: number;
  fytdChange: number;
  fytdPercent: number;
  isTotal?: boolean;
}

export const DSP_COLORS = {
  spotify: '#1DB954',
  youtube: '#FF0000',
  appleMusic: '#FA57C1',
  amazon: '#A0A0A0',
  other: '#FF9500',
} as const;

export const DSP_LABELS = {
  spotify: 'Spotify',
  youtube: 'YouTube',
  appleMusic: 'Apple Music',
  amazon: 'Amazon',
  other: 'Other',
} as const;

// Map customer names from API to display labels
export const CUSTOMER_NAME_TO_DSP: Record<string, string> = {
  Spotify: 'Spotify',
  YouTube: 'YouTube',
  'Apple Music': 'Apple Music',
  Amazon: 'Amazon',
  Other: 'Other',
};

export type DspKey = keyof typeof DSP_LABELS;
